import ActiveCases from './ActiveCases'

export default ActiveCases;